<template lang="pug">
.checkbox-holder(:class="{disabled: $attrs.disabled}")
  .checkbox(:class="styleType")
    label.type-standard
      //isChecked attribut is needed for test
      input(
        type="checkbox"
        :checked="checked"
        :isChecked="checked"
        @change="toggle"
        v-bind="$attrs")
      span.icon-span.mr-XXS
        BriqIcon(name="icon-input-checkbox-icon" :customStyle="{color: 'white'}")
      | {{ label }}
</template>

<script>
export default {
  name: 'BriqCheckboxStandalone',
  inheritAttrs: false,
  props: {
    value: Boolean,
    label: String,
    styleType: {
      type: String,
      required: false,
      default: 'blue-theme',
    },
  },
  data() {
    return { checked: this.value }
  },
  methods: {
    toggle() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    },
  },
  watch: {
    value(newVal) {
      this.checked = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
.blue-theme input:checked + .icon-span
  background #009BFF
  border-color #009BFF

.grey-theme input:checked + .icon-span
  background #4E5A6A
  border-color #4E5A6A

.checkbox
  label
    display flex

  input
    opacity 0
    width 0
    height 0

  .icon
    font-size 8px
    display none
    position absolute
    top 55%
    left 55%
    transform translate(-50%, -50%)
    fill #fff

.checkbox label
  font-weight normal
  cursor pointer

span.icon-span
  outline none
  width 17px
  height 17px
  border-radius 3px
  background #ffffff
  border solid 1px #ececec
  display inline-block
  vertical-align middle
  margin-right 5px
  position relative
  top 2px

.disabled
  label
    cursor not-allowed
    opacity .8

  .checkbox input:checked + .icon-span
    background #4e5a6a
    border-color #4e5a6a
</style>
